module.exports = __webpack_public_path__ + "res/28-img_bg.6322c9431fe5b57c13004eacc1022680.png";